import { calibration_shift_converters, getFieldParser, multi_converters, number_array_or_empty, number_or_0, objectid_array_or_empty, objectid_or_0, objectid_or_null, physical_converters, string_or_empty, threshold_converters, threshold_right_converters, time_converters, } from '../../utils/parser-utils';
import { analog_inputs_parser } from './00-analog-input';
import { output_actions_parser } from './05-output-action';
import { boiler_adapter_parser } from './06-boiler-adapter';
import { web_element_parser } from './10-web-element';
import { scenario_parser } from './11-scenario';
import { threeway_taps_parser } from './15-threeway-tap';
import { heating_circuit_parser } from './16-heating-circuit';
import { heating_modes_parser } from './20-heating-mode';
import { day_timetable_parser } from './21-day-timetable';
import { week_timetable_parser } from './22-week-timetable';
import { ntc_temperature_curve_parser } from './28-ntc-temperature-curve';
import { time_interval_parser } from './33-time-interval';
import { calibration_table_parser } from './36-calibration-table';
import { interval_timetable_parser } from './34-interval-timetable';
import { ui_group_parser } from 'webui/Z3KConfigParser/parser/config-convertor/objects/42-ui-group';
//1
const wired_temperature_sensor_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'name', ...string_or_empty },
    { name: 'upper_threshold', ...threshold_right_converters },
    { name: 'lower_threshold', ...threshold_right_converters },
    { name: 'hysteresis', ...multi_converters(10) },
    { name: 'no_connection_timeout', ...time_converters },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'rol_temperature_upper_threshold', ...objectid_array_or_empty },
    { name: 'rol_temperature_lower_threshold', ...objectid_array_or_empty },
    { name: 'io_extension_id', ...objectid_or_null },
    { name: 'recovery_list', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'position', ...number_or_0 },
    {
        name: 'calibration_shift',
        ...calibration_shift_converters,
    },
];
//2
const guard_zone_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'event_delay_time',
        ...multi_converters(1000),
    },
    {
        name: 'start_delay',
        ...multi_converters(1000),
    },
    { name: 'relative_sensor_list', ...objectid_array_or_empty },
    { name: 'relative_triggered_list', ...objectid_array_or_empty },
    { name: 'relative_recovered_list', ...objectid_array_or_empty },
    { name: 'relative_turned_on', ...objectid_array_or_empty },
    { name: 'relative_turned_off', ...objectid_array_or_empty },
    { name: 'buzzer_guard_indicator_list', ...objectid_array_or_empty },
    { name: 'position', ...number_or_0 },
];
//3
const notification_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'sms_text', ...string_or_empty },
    { name: 'voice_text', ...string_or_empty },
    { name: 'recipient_list', ...objectid_array_or_empty },
];
//4
const user_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'phone', ...string_or_empty },
    { name: 'key_and_radiotag_list', ...objectid_array_or_empty },
    { name: 'role_list', ...objectid_array_or_empty },
    { name: 'password', ...string_or_empty },
    { name: 'setting_register', ...number_or_0 },
];
//7
const radiomodule_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'name', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    { name: 'notification_list', ...objectid_array_or_empty },
    {
        name: 'connection_timeout',
        ...time_converters,
    },
];
//8
const radiosensor_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    { name: 'name', ...string_or_empty },
    {
        name: 'upper_threshold',
        ...threshold_converters,
    },
    {
        name: 'lower_threshold',
        ...threshold_converters,
    },
    {
        name: 'hysteresis',
        ...multi_converters(10),
    },
    { name: 'upper_humidity_threshold', ...number_or_0 },
    { name: 'lower_humidity_threshold', ...number_or_0 },
    { name: 'humidity_hysteresis', ...number_or_0 },
    {
        name: 'no_connection_timeout',
        ...time_converters,
    },
    {
        name: 'movement_leakage_trigger_reset_time',
        ...time_converters,
    },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'rol_temperature_upper_threshold', ...objectid_array_or_empty },
    { name: 'rol_sensor_humidity_out_thresholds', ...objectid_array_or_empty },
    { name: 'rol_movement_leakage_triggered', ...objectid_array_or_empty },
    { name: 'related_radiomodule_id', ...objectid_or_0 },
    { name: 'setting_register', ...number_or_0 },
    { name: 'rol_temperature_lower_threshold', ...objectid_array_or_empty },
    { name: 'rol_sensor_humidity_lower_thresholds', ...objectid_array_or_empty },
    { name: 'position', ...number_or_0 },
    {
        name: 'calibration_shift',
        ...calibration_shift_converters,
    },
];
//9
const command_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'objectid',
        ...objectid_or_0,
        default_from_op: 0,
    },
    { name: 'cmd', ...string_or_empty },
];
//12
const buzzer_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'physical_output',
        ...physical_converters,
    },
    {
        name: 'work_time',
        ...time_converters,
    },
    { name: 'setting_register', ...number_or_0 },
];
//13
const guard_indicator_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'physical_output',
        ...physical_converters,
    },
];
//14
const relay_control_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'physical_output',
        ...physical_converters,
    },
    { name: 'setting_register', ...number_or_0 },
];
//17
const pump_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'physical_output',
        ...physical_converters,
    },
    {
        name: 'delay',
        ...time_converters,
    },
    { name: 'setting_register', ...number_or_0 },
    {
        name: 'pressure_sensor',
        ...objectid_or_null,
    },
    { name: 'pressure_threshold', ...multi_converters(10) },
];
//18
const tm_key_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'serial', ...string_or_empty },
    { name: 'touch_actions', ...objectid_array_or_empty },
];
//19
const user_roles_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'access_level_register', ...number_or_0 },
    { name: 'managed_guard_zone_list', ...objectid_array_or_empty },
    { name: 'user_list', ...objectid_array_or_empty },
];
//24
const io_extension_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'name', ...string_or_empty },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'device_version', ...string_or_empty, default_from_op: 'unknown' },
    { name: 'bus_address', ...number_or_0 },
    { name: 'type', ...number_or_0 },
    { name: 'related_list', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
];
//25
const pza_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'x', ...number_array_or_empty },
    { name: 'y', ...number_array_or_empty },
];
//26
const boiler_group_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'lead_boiler_id',
        ...objectid_or_null,
    },
    { name: 'rotation_period', ...number_or_0 },
    { name: 'setting_register', ...number_or_0 },
    { name: 'slave_boiler_switch_delay', ...number_or_0 },
    { name: 'boiler_list', ...objectid_array_or_empty },
    { name: 'timetables', ...objectid_array_or_empty },
];
//27
const analog_temperature_sensor_fields = [
    { name: 'physical_input_num', ...physical_converters },
    { name: 'name', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    {
        name: 'upper_threshold',
        ...threshold_right_converters,
    },
    {
        name: 'lower_threshold',
        ...threshold_right_converters,
    },
    { name: 'hysteresis', ...multi_converters(10) },
    { name: 'no_connection_timeout', ...time_converters },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'rol_temperature_upper_threshold', ...objectid_array_or_empty },
    { name: 'rol_temperature_lower_threshold', ...objectid_array_or_empty },
    {
        name: 'ntc',
        ...objectid_or_null,
    },
    { name: 'pull_up', ...multi_converters(1000) },
    {
        name: 'calibration_shift',
        ...calibration_shift_converters,
    },
    { name: 'recovery_list', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'position', ...number_or_0 },
];
//29
const fob_fields = [
    { name: 'name', ...string_or_empty },
];
//30
const fob_button_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'unique_id', ...number_or_0 },
    { name: 'commands', ...objectid_array_or_empty },
    { name: 'fob_id', ...objectid_or_0 },
];
//31
const radio_sensor_433_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'unique_id', ...number_or_0 },
    { name: 'type', ...number_or_0 },
    { name: 'rol_triggered', ...objectid_array_or_empty },
    { name: 'trigger_reset_time', ...time_converters },
    { name: 'setting_register', ...number_or_0 },
];
//35
const analog_dut_fields = [
    { name: 'physical_input', ...physical_converters },
    { name: 'name', ...string_or_empty },
    { name: 'signal_normalization', ...number_or_0 },
    { name: 'setting_register', ...number_or_0 },
    { name: 'lower_threshold', ...multi_converters(100) },
    { name: 'no_connection_timeout', ...time_converters },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'calibration', ...objectid_or_0 },
    { name: 'egts', ...number_or_0 },
];
//37
const digital_dut_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'name', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    { name: 'setting_register', ...number_or_0 },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'no_connection_timeout', ...time_converters },
    { name: 'calibration', ...objectid_or_0 },
    { name: 'egts', ...number_or_0 },
];
//38
const radio_dut_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    { name: 'name', ...string_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'no_connection_timeout', ...time_converters },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'related_radiomodule_id', ...objectid_or_0 },
    { name: 'calibration', ...objectid_or_0 },
    { name: 'egts', ...number_or_0 },
    { name: 'common_with', ...objectid_array_or_empty },
    { name: 'config', ...objectid_or_0 },
];
//39
const graph_panel_fields = [
    { name: 'serial', ...string_or_empty },
    { name: 'name', ...string_or_empty },
    { name: 'recipient_address', ...number_or_0 },
    { name: 'circuit_id_in_main_panel', ...objectid_or_null },
    { name: 'type', ...number_or_0, default_from_op: null },
];
//40
const boiler_cascade_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'boiler_list', ...objectid_array_or_empty },
    { name: 'rotation_period', ...number_or_0 },
    { name: 'slave_boiler_start_delay', ...number_or_0 },
    { name: 'slave_boiler_finish_delay', ...number_or_0 },
    { name: 'water_sensor', ...objectid_or_null },
    { name: 'setting_register', ...number_or_0 },
    { name: 'lead_boiler_switch_delay', ...number_or_0 },
    { name: 'hysteresis', ...multi_converters(10) },
    { name: 'preferred_modulation', ...number_or_0 },
];
//43
const object_array_fields = [
    { name: 'objects_links', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
];
//45
const pause_fields = [
    { name: 'time', ...number_or_0 },
];
//46
const conditional_operator_fields = [
    { name: 'type', ...number_or_0 },
    { name: 'comparator_id', ...objectid_or_0 },
    { name: 'statementThen', ...objectid_array_or_empty },
    { name: 'statementElse', ...objectid_array_or_empty },
];
//47
const comparator_fields = [
    { name: 'type', ...number_or_0 },
    { name: 'left_object_id', ...objectid_or_0 },
    { name: 'right_object_id', ...objectid_or_null },
    { name: 'right_const', ...number_or_0 },
];
//48
const logic_expression_fields = [
    { name: 'type', ...number_or_0 },
    { name: 'conditions', ...objectid_array_or_empty },
];
//49
const sensor_reading_fields = [
    { name: 'obj_id', ...objectid_or_null },
    { name: 'type', ...number_or_0 },
    { name: 'argument', ...number_or_0 },
];
//50
const time_comparator_fields = [
    { name: 'type', ...number_or_0 },
    { name: 'comparator_type', ...number_or_0 },
    { name: 'time', ...number_or_0 },
    { name: 'daysOfTheWeek', ...number_or_0 },
];
//51
const modbus_device_fields = [
    { name: 'address', ...number_or_0 },
    { name: 'name', ...string_or_empty },
    { name: 'period', ...number_or_0 },
    { name: 'time_for_disconnect', ...number_or_0 },
    { name: 'rol_connection_lost', ...objectid_array_or_empty },
    { name: 'rol_reconnection', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'signals', ...objectid_array_or_empty },
];
//52
const modbus_signal_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'address', ...number_or_0 },
    { name: 'buffer_length', ...number_or_0 },
    { name: 'buffer_offset', ...number_or_0 },
    { name: 'var_count', ...number_or_0 },
    { name: 'var_length', ...number_or_0 },
    { name: 'var_period_repeat', ...number_or_0 },
    { name: 'setting_register', ...number_or_0 },
    { name: 'type', ...number_or_0 },
    { name: 'division_coefficient', ...number_or_0 },
    { name: 'register_type', ...number_or_0 },
];
//53
const analog_output_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'min_value', ...number_or_0 },
    { name: 'max_value', ...number_or_0 },
    { name: 'step', ...number_or_0 },
    { name: 'unit', ...number_or_0 },
    { name: 'mult', ...number_or_0 },
    { name: 'setting_register', ...number_or_0 },
    { name: 'physical_output', ...number_or_0 },
];
//56
const stop_scenario_fields = [
    { name: 'type', ...number_or_0 },
    { name: 'return_id', ...objectid_or_null },
];
//57
const mqtt_topic_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'type_object', ...number_or_0 },
    { name: 'link_list', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'period', ...number_or_0 },
    { name: 'qos', ...number_or_0 },
];
export const Z3KAnyObjectSpec = {
    //0
    analog_inputs: analog_inputs_parser,
    wired_temperature_sensors: getFieldParser(wired_temperature_sensor_fields),
    guard_zones: getFieldParser(guard_zone_fields),
    notifications: getFieldParser(notification_fields),
    users: getFieldParser(user_fields),
    //5
    output_actions: output_actions_parser,
    boiler_adapters: boiler_adapter_parser,
    radiomodules: getFieldParser(radiomodule_fields),
    radiosensors: getFieldParser(radiosensor_fields),
    commands: getFieldParser(command_fields),
    //10
    web_elements: web_element_parser,
    scenarios: scenario_parser,
    buzzers: getFieldParser(buzzer_fields),
    guard_indicators: getFieldParser(guard_indicator_fields),
    relay_controls: getFieldParser(relay_control_fields),
    //15
    threeway_taps: threeway_taps_parser,
    heating_circuits: heating_circuit_parser,
    pumps: getFieldParser(pump_fields),
    tm_keys: getFieldParser(tm_key_fields),
    user_roles: getFieldParser(user_roles_fields),
    //20
    heating_modes: heating_modes_parser,
    day_timetables: day_timetable_parser,
    week_timetables: week_timetable_parser,
    //23 radio_tags
    io_extensions: getFieldParser(io_extension_fields),
    //25
    pzas: getFieldParser(pza_fields),
    boiler_groups: getFieldParser(boiler_group_fields),
    analog_temperature_sensors: getFieldParser(analog_temperature_sensor_fields),
    ntc_temperature_curves: ntc_temperature_curve_parser,
    fobs: getFieldParser(fob_fields),
    //30
    fob_buttons: getFieldParser(fob_button_fields),
    radiosensors433: getFieldParser(radio_sensor_433_fields),
    //outer_panels:
    time_intervals: time_interval_parser,
    interval_timetables: interval_timetable_parser,
    //35
    analog_duts: getFieldParser(analog_dut_fields),
    calibration_tables: calibration_table_parser,
    digital_duts: getFieldParser(digital_dut_fields),
    radio_duts: getFieldParser(radio_dut_fields),
    graph_panels: getFieldParser(graph_panel_fields),
    //40
    boiler_cascades: getFieldParser(boiler_cascade_fields),
    // dut_settings:
    ui_groups: ui_group_parser,
    object_arrays: getFieldParser(object_array_fields),
    //accelerometers:
    //45
    pauses: getFieldParser(pause_fields),
    conditional_operators: getFieldParser(conditional_operator_fields),
    comparators: getFieldParser(comparator_fields),
    logic_expressions: getFieldParser(logic_expression_fields),
    sensor_readings: getFieldParser(sensor_reading_fields),
    //50
    time_comparators: getFieldParser(time_comparator_fields),
    modbus_devices: getFieldParser(modbus_device_fields),
    modbus_signals: getFieldParser(modbus_signal_fields),
    analog_outputs: getFieldParser(analog_output_fields),
    //signals:
    //55
    //slots:
    stop_scenarios: getFieldParser(stop_scenario_fields),
    mqtt_topics: getFieldParser(mqtt_topic_fields),
};
